export const EXAMPLE_PROMPTS = [
  {
    prompt: 'Now hiring a cashier.',
    theme: 'hiring',
    generates: ['Hiring graphic', 'QR code', 'Animated background', 'Professional layout'],
  },
  {
    prompt: 'Fresh Injera available today.',
    theme: 'injera',
    generates: ['Ethiopian themed design', 'Motion graphics', 'Beautiful typography'],
  },
  {
    prompt: 'Lakers game tonight.',
    theme: 'lakers',
    generates: ['Countdown', 'Sports themed graphics', 'Game night announcement'],
  },
  {
    prompt: 'Happy Birthday Maria!',
    theme: 'birthday',
    generates: ['Celebration animation', 'Confetti', 'Company branding'],
  },
  {
    prompt: 'All candy bars 2 for $3',
    theme: 'candy',
    generates: ['Polished promotional slide', 'Price callout', 'Eye-catching layout'],
  },
];

export const AI_FEATURES = [
  {
    title: 'AI Promotion Generator',
    description: 'Type one sentence. Receive a professionally animated promotion with typography, colors, and motion — in seconds.',
    icon: '✦',
  },
  {
    title: 'AI Scheduler',
    description: 'Say "Run this every Friday from 4 PM until 8 PM." Done. Natural language scheduling for every screen.',
    icon: '◷',
  },
  {
    title: 'AI Branding',
    description: 'Automatically uses your logo, brand colors, fonts, and photos across every screen. Every generation gets smarter.',
    icon: '◈',
  },
  {
    title: 'AI Suggestions',
    description: 'Proactive recommendations: weather promos, game day specials, stale hiring slides — one click to generate.',
    icon: '◎',
  },
];

export const APPLICATIONS = [
  { title: 'AI Promotions', prompt: 'Happy Hour starts at 4 PM', theme: 'happyHour' },
  { title: 'Menus', prompt: 'Today\'s lunch specials', theme: 'coffee' },
  { title: 'Hiring', prompt: 'Now hiring baristas', theme: 'hiring' },
  { title: 'Daily Specials', prompt: 'Fresh pastries — baked this morning', theme: 'coffee' },
  { title: 'Announcements', prompt: 'We\'re open on Labor Day', theme: 'happyHour' },
  { title: 'Community Events', prompt: 'Live music Friday night', theme: 'birthday' },
  { title: 'Social Posts', prompt: 'Follow us @bettymarket', theme: 'injera' },
  { title: 'Local Cross Promotions', prompt: 'Partner with Joe\'s Pizza — 10% off', theme: 'candy' },
  { title: 'Revenue Sharing', prompt: 'Monetize unused screen time', theme: 'lakers', highlight: true },
];

export const PRICING_TIERS = [
  {
    name: 'Starter',
    price: 'Free',
    period: '',
    description: 'Perfect for trying INVERT on your first screens.',
    features: [
      'Up to 3 screens',
      '50 AI generations / month',
      'Basic scheduling',
      'Content library',
      'Passive ad revenue',
    ],
    cta: 'Get Started',
    highlighted: false,
  },
  {
    name: 'Business',
    price: '$49',
    period: '/month',
    description: 'Everything you need to run intelligent displays.',
    features: [
      'Unlimited screens',
      'Unlimited AI generations',
      'Smart scheduling',
      'AI suggestions',
      'Brand memory',
      'Priority support',
      'Ad revenue sharing',
    ],
    cta: 'Start Free Trial',
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'Multi-location businesses and franchises.',
    features: [
      'Everything in Business',
      'Multi-location management',
      'API access',
      'Custom integrations',
      'Dedicated account manager',
      'SLA guarantee',
    ],
    cta: 'Contact Sales',
    highlighted: false,
  },
];
